import React from "react";

const ImageInfo = () => {
	return (
		<svg
			className="image-info"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			width="24"
			height="24"
			viewBox="0 0 24 24"
		>
			<path
				fill="#FFF"
				transform="translate(10 2)"
				d="M.476 20V6.573h3.356V20H.476zM0 2.014C0 .951.895 0 2.126 0c1.23 0 2.182.867 2.182 2.014 0 1.147-.951 2.014-2.182 2.014C.896 4.028 0 3.077 0 2.014z"
			/>
		</svg>
	);
};

export default ImageInfo;
